import _uniqueId from "lodash/uniqueId";
import React from 'react';
import { View, Text } from '@react-pdf/renderer';
import { YYYYMMDDtoMMDDYY } from '@mummssoftware/utils/formatters';
import { styles } from '../../utils';
import defaults from '../../translations/en.json';
import { combined, refused, total, weekdayHeaders, weekdayPrefixes } from './constants';
import { makeDetailsHash } from './utils';

const getRowStyle = index => [styles.width100, {
  backgroundColor: index % 2 === 1 ? '#d9d9d9' : 'white'
}];

const HeaderColumns = () => /*#__PURE__*/React.createElement(React.Fragment, null, weekdayHeaders.map(title => /*#__PURE__*/React.createElement(View, {
  style: styles.width8
}, /*#__PURE__*/React.createElement(Text, {
  key: title,
  style: [styles.fontWeightBold, styles.fontSizeTwelvePt, styles.textAlignCenter]
}, title))), /*#__PURE__*/React.createElement(View, {
  style: styles.width13
}, /*#__PURE__*/React.createElement(Text, {
  key: _uniqueId(`weekheader-`),
  style: [styles.fontWeightBold, styles.fontSizeTwelvePt]
}, defaults.total)));

var _ref = /*#__PURE__*/React.createElement(HeaderColumns, null);

const TaskWeekHeader = ({
  startday
}) => /*#__PURE__*/React.createElement(View, null, /*#__PURE__*/React.createElement(View, {
  style: [styles.width100, styles.row, styles.backgroundColorDarkGray, styles.paddingPointOneCm]
}, /*#__PURE__*/React.createElement(View, {
  style: styles.width30
}, /*#__PURE__*/React.createElement(Text, {
  style: (styles.fontWeightBold, styles.fontSizeTwelvePt)
}, "TASKS: Week beg. ", YYYYMMDDtoMMDDYY(startday))), _ref));

const TaskNotes = ({
  notes,
  task,
  index
}) => /*#__PURE__*/React.createElement(View, {
  style: [styles.paddingLeftPointTwoCm, getRowStyle(index)]
}, notes && notes[task.entitykey] && notes[task.entitykey].map(note => /*#__PURE__*/React.createElement(Text, {
  key: `additional-detail-${task && task.key}-${note.id}`,
  style: [styles.fontSizeTenPt, styles.pYPointOneCm]
}, `• ${note.note}`)));

const TaskCount = ({
  completed,
  ptRefused
}) => /*#__PURE__*/React.createElement(React.Fragment, null, `${completed || ''} ${ptRefused ? `${ptRefused}X` : ''}`);

const WeekdayCounts = ({
  task
}) => /*#__PURE__*/React.createElement(React.Fragment, null, weekdayPrefixes.map(day => /*#__PURE__*/React.createElement(Text, {
  style: [styles.width8, styles.fontSizeTenPt, styles.pYPointOneCm, styles.textAlignCenter],
  key: day
}, task[`${day}${combined}`] > 0 && /*#__PURE__*/React.createElement(TaskCount, {
  completed: task[`${day}${total}`],
  ptRefused: task[`${day}${refused}`]
}))));

const TaskRow = ({
  task,
  index
}) => /*#__PURE__*/React.createElement(View, {
  style: getRowStyle(index),
  key: _uniqueId(`${task.key}-`)
}, /*#__PURE__*/React.createElement(View, {
  style: [styles.row, styles.width100, styles.paddingPointOneCm]
}, /*#__PURE__*/React.createElement(Text, {
  style: [styles.width30, styles.fontSizeTenPt, styles.pYPointOneCm, {
    paddingLeft: task.tasktext.startsWith('\t') ? '0.2cm' : '0cm'
  }]
}, task.tasktext || '-'), /*#__PURE__*/React.createElement(WeekdayCounts, {
  task: task
}), /*#__PURE__*/React.createElement(Text, {
  style: [styles.width13, styles.fontSizeTenPt, styles.pYPointOneCm, styles.paddingLeftPointFourCm]
}, task.weektotal)));

export const TaskWeek = ({
  week,
  tasks,
  withDetails,
  includeNotes,
  notes
}) => tasks ? /*#__PURE__*/React.createElement(View, {
  style: {
    border: '2px solid black'
  }
}, /*#__PURE__*/React.createElement(TaskWeekHeader, {
  startday: week
}), tasks.map((task, index) => {
  const adminMap = withDetails && makeDetailsHash(task);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(TaskRow, {
    task: task,
    index: index
  }), withDetails && Object.keys(adminMap).map(personid => /*#__PURE__*/React.createElement(TaskRow, {
    key: personid,
    task: adminMap[personid],
    index: index
  })), includeNotes && /*#__PURE__*/React.createElement(TaskNotes, {
    notes: notes,
    task: task,
    index: index
  }));
})) : /*#__PURE__*/React.createElement(React.Fragment, null);